import axios from 'axios';
import getCookie from "../utils/cookieUtils";
import { store } from '../services/store';
import { setErrorMessage } from '../services/403Error/errorSlice';
import { attemptTokenRefresh } from './refreshToken';

const apiClient = axios.create();

apiClient.interceptors.request.use((config) => {
    const token = getCookie('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));

apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const newToken = await attemptTokenRefresh();
                originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                apiClient.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
                return apiClient(originalRequest);
            } catch {
                return Promise.reject(error);
            }
        }

        if (error.response?.status === 403) {
            store.dispatch(setErrorMessage('Du har ikke tilgang til å utføre denne handlingen.'));
        }

        return Promise.reject(error);
    }
);

export default apiClient;